module.exports = __webpack_public_path__ + "img/logo.7f0e5106.png";